import { FC, ReactNode } from "react";
import styled from "@emotion/styled";

import AuthIllustrationImage from "@/assets/images/fullscreen-illustration.svg?react";
import { MDSLogo, MDSLogoKind } from "@/mds";

interface FullScreenOverlayProps {
  children: ReactNode;
  className?: string;
  /**
   * Disable body scrolling while the overlay is visible.
   */
  disableScroll?: boolean;
}

export const FullScreenOverlay: FC<FullScreenOverlayProps> = ({ children, className }) => {
  return (
    <Wrapper className={className}>
      <IllustrationContainer>
        <Illustration aria-hidden />
      </IllustrationContainer>
      <Content>{children}</Content>
      <StyledLogo kind={MDSLogoKind.Lockup} aria-hidden className="full-screen-overlay-wordmark" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surface.onboarding};
  padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[4]};
  z-index: 9999;
  overflow: auto;
  max-width: 100vw;
  max-height: 100vh;
  overflow: hidden;
`;

const Content = styled.div`
  pointer-events: auto;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Illustration = styled(AuthIllustrationImage)`
  color: ${({ theme }) => theme.colors.background.illustration.contrast};
  max-height: 1100px;
  width: auto;
  min-width: 400px;
  opacity: 0.85;
  pointer-events: none;
  z-index: 0;
  margin-left: 10vw;
  margin-bottom: calc(10vw - 200px);
`;

const IllustrationContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

const StyledLogo = styled(MDSLogo)`
  position: absolute;
  right: ${({ theme }) => theme.spacing[5]};
  bottom: ${({ theme }) => theme.spacing[5]};
  height: 24px;
  width: auto;
  pointer-events: none;

  @media (min-width: 1024px) {
    height: 32px;
  }
`;
